export const getIsUserCancel = (error: Error) => {
  const errorMsg = error.message.toLowerCase()
  const isUserCancel =
    errorMsg.includes('user rejected') || errorMsg.includes('user denied')
  return isUserCancel
}

export const getFromParam = (routerQuery: any): string => {
  const { from } = routerQuery
  if (typeof from === 'string') {
    const validFromValues = [
      'stETH-wrap',
      'stETH-withdraw',
      'wstETH-unwrap',
      'wstETH-withdraw',
      'homepage',
      'stake',
      'wrap',
      'withdraw',
      'direct',
    ]
    return validFromValues.includes(from) ? from : 'direct'
  }
  return 'direct'
}
